/**
 * WireScript Schema v2 - Prop Definitions
 *
 * Schema-first approach with type inference (like Zod/TypeBox).
 */
// =============================================================================
// Prop Definition Helpers
// =============================================================================
/** Boolean prop - defaults to true when present without value */
export function bool(def) {
    return { type: 'boolean', default: (def ?? true) };
}
/** Number prop */
export function num(def) {
    return { type: 'number', default: def };
}
/** String prop */
export function str(def) {
    return { type: 'string', default: def };
}
/** Symbol prop (unquoted identifier) */
export function sym(def) {
    return { type: 'symbol', default: def };
}
/** Any value type */
export function any() {
    return { type: 'any' };
}
/** Navigation target */
export function nav() {
    return { type: 'navigation' };
}
// =============================================================================
// Prop Groups
// =============================================================================
/** Layout direction props */
export const layoutProps = {
    row: bool(),
    col: bool(),
    grid: bool(),
    wrap: bool(),
};
/** Alignment props */
export const alignProps = {
    center: bool(),
    start: bool(),
    end: bool(),
    between: bool(),
    around: bool(),
    stretch: bool(),
};
/** Size props */
export const sizeProps = {
    full: bool(),
    fit: bool(),
    fill: bool(),
};
/** Spacing props */
export const spacingProps = {
    gap: num(0),
    padding: num(0),
};
/** Dimension props */
export const dimensionProps = {
    width: any(),
    height: any(),
};
/** Position props */
export const positionProps = {
    sticky: bool(),
    fixed: bool(),
    absolute: bool(),
    relative: bool(),
    top: num(),
    left: num(),
    right: num(),
    bottom: num(),
};
/** Variant props */
export const variantProps = {
    primary: bool(),
    secondary: bool(),
    ghost: bool(),
    danger: bool(),
    success: bool(),
    warning: bool(),
    info: bool(),
};
/** State props */
export const stateProps = {
    disabled: bool(),
    loading: bool(),
    active: bool(),
    checked: bool(),
    open: bool(),
    error: bool(),
};
/** Emphasis props */
export const emphasisProps = {
    high: bool(),
    medium: bool(),
    low: bool(),
};
/** Navigation props */
export const navigationProps = {
    to: nav(),
};
// =============================================================================
// Composed Prop Groups
// =============================================================================
/** Container props (layout + align + size + spacing + dimension + position) */
export const containerProps = {
    ...layoutProps,
    ...alignProps,
    ...sizeProps,
    ...spacingProps,
    ...dimensionProps,
    ...positionProps,
};
/** Content props (emphasis + size + dimension + navigation) */
export const contentProps = {
    ...emphasisProps,
    ...sizeProps,
    ...dimensionProps,
    ...navigationProps,
};
/** Interactive props (variant + size + dimension + navigation + states) */
export const interactiveProps = {
    ...variantProps,
    ...sizeProps,
    ...dimensionProps,
    ...navigationProps,
    disabled: bool(),
    loading: bool(),
    active: bool(),
};
//# sourceMappingURL=props.js.map